import Route from '@ember/routing/route';
import { service } from '@ember/service';

import type { Service } from 'webapp-types';
import { BillingFeature } from 'webapp/enums/enums';

export default class ArtifactsRoute extends Route {
	@service('ai-chat') declare aiChatService: Service.AIChat;
	@service('navigation') declare navigationService: Service.Navigation;

	override async beforeModel(): Promise<void> {
		document.body.id = 'page-genie-artifacts';

		await this.navigationService.initialRequestsPromise;

		if (!this.aiChatService.isAiChatAvailable) {
			this.navigationService.replaceRoute('index');

			return;
		}

		this.aiChatService.redirectIfFeatureGated(BillingFeature.AI_ARTIFACTS);
	}
}
